// create CRUD class with axios
import axios, {AxiosResponse} from "axios";
import ThermalPrinterBase from "./ThermalPrinterBase";
import dayjs from "dayjs";

import {SETTING_ID} from "~~/interface/Setting";
import {PRINTER_JOB_MODE, PRINTER_VOID_ITEM_VALUES, normalizePrinterJobModes, sortPrinterJobModesForPrint} from "~~/interface/PrinterJobMode";
import _ from 'lodash';
import { getDoc, setDoc } from "firebase/firestore";
import { FIRESTORE_COLLECTIONS } from "~/interface/FirestoreCollections";

const PRINTER_NAME = "pos8080";
// const PRINTER_LIST = [
//     "p0",
//     "p1",
//     "p2",
//     "p3",
//     "p4",
//     "p5"
// ];
// const PRINTER_LIST_SETTING = [
//     SETTING_ID.PRINTER_0_MODE,
//     SETTING_ID.PRINTER_1_MODE,
//     SETTING_ID.PRINTER_2_MODE,
//     SETTING_ID.PRINTER_3_MODE,
//     SETTING_ID.PRINTER_4_MODE,
//     SETTING_ID.PRINTER_5_MODE,
// ];

export default class ThermalPrinterJob extends ThermalPrinterBase {
    tempItemsPrintReadyHolder : any = {}; //items seted printer and ready to print
    printerOriginalHolder : any = {};
    PRINTER_LIST = [];
    PRINTER_LIST_SETTING = [];   
    
    constructor(){
        super();    
        const maxPrinter = useGetMaxPrinter();
        for(let i=0; i<maxPrinter;i++){ 
            this.PRINTER_LIST.push(`p${i}` as never);
            this.PRINTER_LIST_SETTING.push(`printer_${i}_mode` as never);
        }

        console.log("PRINTER_LIST:", this.PRINTER_LIST);
        console.log("PRINTER_LIST_SETTING:", this.PRINTER_LIST_SETTING);

    }

    printCustomMode(job, printerService) {
        const settingsStore = useSettingsStore();
        const productsStore = useProductsStore();
        const productGroupsHolder = productsStore.getProductGroupsByItemHolder();

        // loop for printers
        for (let index = 0; index < this.PRINTER_LIST.length; index++) {
            let presetIndex = index
            const printer = this.PRINTER_LIST[index];
            const PRINTER_MODE_SETTING_BY_PRINTER = this.PRINTER_LIST_SETTING[index];

            // filter items by printer
            const jobItems = job.items || [];
            let items = jobItems.filter((item: any) => {
                let printerForThisItem = printerService.getPrinter(item.productId) || {};
                return printerForThisItem[printer] == true;
            });    

            //build original holder
            jobItems.forEach((item : any) => {
                let printerForThisItem = printerService.getPrinter(item.productId) || {};
                if(!this.printerOriginalHolder[item.productId]){
                    this.printerOriginalHolder[item.productId] = printerForThisItem[printer] ? printer : null
                }               
            })

            // if no item, skip
            if (items.length == 0) {
                continue;
            }

            this.tempItemsPrintReadyHolder[printer] = items
            this.printWithMode(job, printer, items, presetIndex, PRINTER_MODE_SETTING_BY_PRINTER)
        }


        return this
    }


    withForwardZone(job : any) { 
        const settingsStore = useSettingsStore();
        const posStore = usePosStore()
        const printForwardSettings = settingsStore.getValueBysettingId("print_forwards", {});
        const zone = posStore ?. selectedZone || null

        if (! zone) {
            return this
        }        

        const printForwardHolder = printForwardSettings[zone.zoneId] || {}       
        const queues = [...this.print_queues]
   
        let newQueues = []
    
        // QUEUE ITEMS
        for (let index = 0; index < queues.length; index++) {
            const queue = queues[index];
            let printerPreset = queue.printerPreset
            let printerPresetName = `p${printerPreset}` // FROM BEFORE FORWARD
            let forwardList = printForwardHolder[printerPresetName] || []            
            let itemsBuiled = this.tempItemsPrintReadyHolder[printerPresetName] || []              

            // LOOP FOR PRINT FROM FORWARD LIST
            if (forwardList.length > 0) {
                this.print_queues = []
                // add forward printer
                itemsBuiled = itemsBuiled.map((item : any) => {
                    return {...item, forwardPrinters: forwardList}
                })   

                for (let index = 0; index < forwardList.length; index++) {
                    const toPrinter = forwardList[index]; // output to p1,p2...
                    let presetNumber = this.printerMappingWithCode(toPrinter) // output to 1,2,3...                          
                    console.log("print to =>", toPrinter)   

                    const printerSettingName = this.PRINTER_LIST_SETTING[presetNumber]
                    this.printWithMode(job, toPrinter, itemsBuiled, presetNumber, printerSettingName)
                } 
                newQueues.push(this.print_queues)
            }else{
                newQueues.push(queues[index])
            }
        }

        // WHEN NO QUEUE AND HAS ITEMS NOT SET PRINTER
        if(queues.length == 0){
            this.checkAndUpdateItemJobToDb(job, job.items)
        }
    
        const flatNewQueues = _.flatMap(newQueues)

        this.print_queues = flatNewQueues
        this.tempItemsPrintReadyHolder = {}
        this.printerOriginalHolder = {}
        return this
    }
 
    printWithMode(job : any, printer : any, items : any, presetIndex : any, printerSettingName : any) {
        const productsStore = useProductsStore();
        const settingsStore = useSettingsStore();

        const productGroupsHolder = productsStore.getProductGroupsByItemHolder();

        // 1 printer เลือกได้หลายโหมด (ค่าเดิมที่เป็น string เดี่ยว/โหมดรวม จะถูกแปลงเป็น array ให้)
        const printModes = normalizePrinterJobModes(
            settingsStore.getValueBysettingId(printerSettingName, PRINTER_JOB_MODE.SUMMARY)
        );

        // ลำดับพิมพ์ยึดตาม A/B/C/D ใน UI ไม่ใช่ลำดับที่ผู้ใช้กดเลือก
        // (เลือก D ก่อน A ก็ยังพิมพ์ A ก่อน D)
        const modeBuilders: Record<string, () => void> = {
            // A. รวมทุกรายการใน 1 ใบ
            [PRINTER_JOB_MODE.SUMMARY]: () =>
                this.buildSummaryOuput(job, printer, items, presetIndex),
            // B. แยกใบตามกลุ่มสินค้า
            [PRINTER_JOB_MODE.BY_PRODUCT_GROUP]: () =>
                this.buildPrintByProductGroupOutput(job, printer, items, productGroupsHolder, presetIndex),
            // C. แยกใบตามรายการ
            [PRINTER_JOB_MODE.ONE_BY_ONE]: () =>
                this.buildOneByOneOutput(job, printer, items, presetIndex),
            // D. แยกใบตาม Qty
            [PRINTER_JOB_MODE.ONE_QTY_EACH]: () =>
                this.buildOneQtyEachOutput(job, printer, items, presetIndex),
        };

        sortPrinterJobModesForPrint(printModes).forEach((mode) => {
            modeBuilders[mode]?.();
        });
    }

    // Reprint หรือ ตามอาหาร
    rePrintJob(job, printerService) {
        const settingsStore = useSettingsStore();
        const isShowItemPrice = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_JOB_SHOW_PRICE, 0);

        // loop for printers
        for (let index = 0; index < this.PRINTER_LIST.length; index++) {
            const printer = this.PRINTER_LIST[index];

            // filter items by printer
            let items = job.items.filter((item: any) => {
                let printerForThisItem = printerService.getPrinter(item.productId) || {};
                return printerForThisItem[printer] == true;
            });

            // if no item, skip
            if (items.length == 0) {
                continue;
            }

            let content = [];

            // draw detail store
            content.push({
                type: "text",
                value: `printer ${printer} ${index}`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 10,
                    fontStyle: "normal",
                    align: "center"
                }
            }, {
                type: "newline",
                value: "10"
            }, {
                type: "text",
                value: `Date :  ${
                    dayjs(job.timestamp).format("DD/MM/YYYY HH:mm:ss")
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "text",
                value: `Employee :  ${
                    job.employee.name
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "newline",
                value: "20"
            }, {
                type: "text",
                value: `*** ${
                    job.reprintType || "Reprint"
                } ***`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 15,
                    fontStyle: "bold",
                    align: "center"
                }
            }, {
                type: "text",
                value: `Table ${
                    job.table
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 16,
                    fontStyle: "bold",
                    align: "center"
                }
            }, {
                type: "newline",
                value: "10"
            }, {type: "line"});
            // draw items
            items.forEach((item) => {
                content.push({
                        type: "text2cols", value: `${
                        item.qty
                    }   ${
                        item.name
                    } (${
                        job.reprintType || "Reprint"
                    })`,
                    value2: `${
                        isShowItemPrice ? item.price : ""
                    }`,
                    // value2: ` `,
                    style: {
                        fontFamily: "Arial",
                        fontSize: 16,
                        fontStyle: "normal"
                    }
                });

                if (item.options2 && item.options2.length > 0) {
                    item.options2.forEach((option) => {
                        content.push({
                                type: "text2cols", value: `     - ${
                                option.name
                            }  x${
                                option.qty
                            }`,
                            value2: ` `,
                            style: {
                                fontFamily: "Arial",
                                fontSize: 15,
                                fontStyle: "normal"
                            }
                        });
                    });
                }

                if (item.comments) {
                    content.push({
                            type: "text2cols", value: `     # ${
                            item.comments
                        }`,
                        value2: ` `,
                        style: {
                            fontFamily: "Arial",
                            fontSize: 15,
                            fontStyle: "normal"
                        }
                    });
                }
            });
            // draw line
            content.push({type: "line"});

            let cmd = {
                // printerName: PRINTER_NAME,
                printerPreset: index.toString(),
                timestamp: new Date().toISOString(),
                date: dayjs().format("YYYY-MM-DD"),
                jobId: new Date().valueOf().toString() + "_" + printer,
                content
            };
            this.print_queues.push(cmd);
        }

        return this;
    }

    printOneEachQty(job) { // draw items
        let allprinters = this.getPrintersThatUsed(job.items);
        allprinters.forEach((i) => {
            job.items.forEach((item) => {
                let contents = [];
                let cmd = {
                    printer: i,
                    contents: contents
                };
                // draw header
                contents.push({
                        type: "text", text: `Date :  ${
                        job.timestamp
                    } `
                });
                contents.push({
                        type: "text", text: `Employee :  ${
                        job.employee.name
                    }`
                });

                // draw body
                contents.push({
                    type: "text",
                    text: `TABLE :  ${
                        job.table
                    }`,
                    align: "center",
                    fontSize: 14,
                    bold: true,
                    fontFamily: "Arial",
                    italic: true,
                    underline: true,
                    strike: true
                });

                // draw type new line
                contents.push({
                    type: "line",
                    line: "single",
                    thickness: 2,
                    width: 1,
                    align: "center"
                });

                // text left and right in the same line
                contents.push({
                        type: "text", text: `${
                        item.qty
                    } x ${
                        item.name
                    }`,
                    align: "left",
                    fontSize: 14
                });
                contents.push({
                        type: "text", text: `${
                        item.price
                    }`,
                    align: "right",
                    fontSize: 14
                });

                // draw modifuer
                if (item.modifier) {
                    contents.push({
                            type: "text", text: `  - ${
                            item.modifier
                        }`,
                        fontSize: 12,
                        italic: true
                    });
                }

                contents.push({type:"newline", value: "10"})

                // draw note
                if (item.note) {
                    contents.push({
                            type: "text", text: `${
                            item.note
                        }`
                    });
                }
                // draw type new line
                contents.push({
                    type: "line",
                    line: "single",
                    thickness: 2,
                    width: 1,
                    align: "center"
                });

                // send to printer
                this.print_queues.push(cmd);
            });
        });
    }

    printMoveItems(job : any, printerService) {
        const settingsStore = useSettingsStore();
        const canMoveItem = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_JOB_MOVE_TABLE, false);
        if (! canMoveItem) 
            return this;
        


        for (let index = 0; index < this.PRINTER_LIST.length; index++) {
            const printer = this.PRINTER_LIST[index];

            // filter items by printer
            let items = job.items.filter((item: any) => {
                let printerForThisItem = printerService.getPrinter(item.productId) || {};
                return printerForThisItem[printer] == true;
            });

            if (items.length == 0) {
                continue;
            }

            let content = [];
            // draw detail header
            content.push({
                    type: "text", value: `Date :  ${
                    dayjs(job.timestamp).format("DD/MM/YYYY HH:mm:ss")
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "text",
                value: `Employee :  ${
                    job.employee.name
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "text",
                value: `Printer : ${
                    printer.replace("p", "")}`,  
              
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "newline",
                value: "10"
            });

            // draw table move to
            content.push({
                    type: "text", value: `Table ${
                    job.table[0]
                } ย้ายไป ${
                    job.table[1]
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 16,
                    fontStyle: "bold",
                    align: "center"
                }
            }, {
                type: "newline",
                value: "10"
            }, {
                type: "line"
            });

            content.push({type: "newline", value: this.customFontSize().newLine});

            // draw detail move
            content.push({
                type: "text",
                value: `**   หากมีรายการค้าง`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 10,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "text",
                value: `**   ย้ายจากโต๊ะ ${
                    job.table[0]
                } ==> ${
                    job.table[1]
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 10,
                    fontStyle: "normal",
                    align: "left"
                }
            },
            // {
            //     type: 'text',
            //     value: `**   (ย้ายบางรายการ ดังนี้)`,
            //     style: {
            //         fontFamily: 'Arial',
            //         fontSize: 10,
            //         fontStyle: 'normal',
            //         align: 'left'
            //     }
            // },
            );
            content.push({type: "newline", value: this.customFontSize().newLine});

            // draw items move
            for(let i = 0; i < items.length; i++){
                let item = items[i];
                content.push({
                        type: "text", value: `${
                        item.qty
                    }   ${
                        item.name
                    }`,
                    style: {
                        fontFamily: "Arial",
                        fontSize: this.customFontSize().main,
                        fontStyle: "normal",
                        align: "left"
                    }
                }, {
                    type: "text",
                    value: `     - ย้าย (${
                        job.table[0]
                    } ==> ${
                        job.table[1]
                    })`,
                    style: {
                        fontFamily: "Arial",
                        fontSize: this.customFontSize().sub,
                        fontStyle: "normal",
                        align: "left"
                    }
                });

                // add newline if not last item
                if(i < items.length - 1){
                    content.push({type: "newline", value: this.customFontSize().newLine});
                }
            }

            content.push({type: "newline", value: this.customFontSize().newLine});
            content.push({type: "line"});

            let cmd = {
                printerPreset: index.toString(),
                timestamp: new Date().toISOString(),
                date: dayjs().format("YYYY-MM-DD"),
                jobId: new Date().valueOf().toString() + index,
                content
            };
            this.print_queues.push(cmd);
        }

        return this;
    }

    printVoidCustom(job, printerService) {
        const settingsStore = useSettingsStore();
        const voidItemSetting = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_JOB_VOID_ITEMS, PRINTER_VOID_ITEM_VALUES.NONE);
        console.info("STARTING PRINT VOID ITEM MODE====>", voidItemSetting);

        // OLD SETTING (FALSE) OR NEW SETTING (NONE)  TO DON'T PRINT
        if (voidItemSetting == PRINTER_VOID_ITEM_VALUES.NONE) {}

        // OLD SETTING (BOOLEAN)  TO PRINT ALL
        if (voidItemSetting === true) {
            this.buildVoidItemsToCashier(job);
        }

        // PRINTER STATAIONS
        if (voidItemSetting == PRINTER_VOID_ITEM_VALUES.STATIONS_ONLY) {
            this.printVoidItems(job, printerService);
        }

        // PRINTER CASHIER
        if (voidItemSetting == PRINTER_VOID_ITEM_VALUES.CASHIER_ONLY) {
            this.buildVoidItemsToCashier(job);
        }

        // PRINTER CASHIER AND STATAIONS
        if (voidItemSetting == PRINTER_VOID_ITEM_VALUES.CASHIER_AND_STATIONS) {
            this.buildVoidItemsToCashier(job);
            this.printVoidItems(job, printerService);
        }

        return this;
    }

    printVoidItems(job: any, printerService: any) {
        for (let index = 0; index < this.PRINTER_LIST.length; index++) {
            const printer = this.PRINTER_LIST[index];

            // filter items by printer
            let items = job.items.filter((item: any) => {
                let printerForThisItem = printerService.getPrinter(item.productId) || {};
                return printerForThisItem[printer] == true;
            });

            if (items.length == 0) {
                continue;
            }


            let content = [];

            // draw detail header
            content.push({
                    type: "text", value: `Date :  ${
                    dayjs(job.timestamp).format("DD/MM/YYYY HH:mm:ss")
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "text",
                value: `Employee :  ${
                    job.employee.name
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "text",
                value: `Printer :  ${
                    printer.replace("p", "")
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "newline",
                value: "15"
            }, {
                type: "text",
                value: `${
                    job.table
                } (ยกเลิกรายการ)`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 14,
                    fontStyle: "bold",
                    align: "center"
                }
            }, {
                type: "newline",
                value: "10"
            }, {
                type: "line"
            }, {
                type: "newline",
                value: "10"
            });

            // draw item
            items.forEach((item) => {
                content.push({
                        type: "text", value: `${
                        item.qty
                    }  ${
                        item.name
                    } (ยกเลิก)`,
                    style: {
                        fontFamily: "Arial",
                        fontSize: this.customFontSize().main,
                        fontStyle: "strikeOut",
                        align: "left"
                    }
                });

            });

            // draw footer
            content.push({
                type: "newline",
                value: "10"
            }, {
                type: "line"
            }, {
                type: "newline",
                value: "10"
            }, {
                type: "text",
                value: `Reason : ${
                    job.note
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 10,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "newline",
                value: "10"
            }, {
                type: "text",
                value: `Sign : _________________`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 10,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "newline",
                value: "10"
            });

            let cmd = {
                printerPreset: index.toString(),
                timestamp: new Date().toISOString(),
                date: dayjs().format("YYYY-MM-DD"),
                jobId: new Date().valueOf().toString() + index,
                content
            };
            this.print_queues.push(cmd);
        }
        return this;
    }

    // voided items to cashier
    buildVoidItemsToCashier(job) {
        let content = [];

        // draw detail store
        content.push({
            type: "text",
            value: `*** Original Copy to Cashier ***`,
            style: {
                fontFamily: "Arial",
                fontSize: 10,
                fontStyle: "normal",
                align: "center"
            }
        }, {
            type: "newline",
            value: "10"
        }, {
            type: "text",
            value: `Date :  ${
                dayjs(job.timestamp).format("DD/MM/YYYY HH:mm:ss")
            }`,
            style: {
                fontFamily: "Arial",
                fontSize: 9,
                fontStyle: "normal",
                align: "left"
            }
        }, {
            type: "text",
            value: `Employee :  ${
                job.employee.name
            }`,
            style: {
                fontFamily: "Arial",
                fontSize: 9,
                fontStyle: "normal",
                align: "left"
            }
        }, 
        {type:"newline",value:"15"},
        {
            type: "text",
            value: `${
                job.table
            } (ยกเลิกสินค้า)`,
            style: {
                fontFamily: "Arial",
                fontSize: 14,
                fontStyle: "bold",
                align: "center"
            }
        }, {
            type: "newline",
            value: "10"
        }, 
        {type: "line"},
        );

        content.push({type: "newline", value: this.customFontSize().newLine});
        
        // draw items
        for(let i = 0; i < job.items.length; i++){
            let item = job.items[i];
            content.push({
                    type: "text2cols", value: `${
                    item.qty
                }   ${
                    item.name
                }`,
                // value2: `${item.price}`,
                value2: ` `,
                style: {
                    fontFamily: "Arial",
                    fontSize: 14,
                    fontStyle: "strikeOut"
                }
            });

            if (item.options2 && item.options2.length > 0) {
                item.options2.forEach((option) => {
                    content.push({
                            type: "text2cols", value: `     - ${
                            option.name
                        }  x${
                            option.qty
                        }`,
                        value2: ` `,
                        style: {
                            fontFamily: "Arial",
                            fontSize: 15,
                            fontStyle: "strikeOut"
                        }
                    });
                });
            }

            if (item.comments) {
                content.push({
                        type: "text2cols", value: `     # ${
                        item.comments
                    }`,
                    value2: ` `,
                    style: {
                        fontFamily: "Arial",
                        fontSize: 15,
                        fontStyle: "normal"
                    }
                });
            }

            // add newline if not last item
            if(i < job.items.length - 1){
               content.push({type: "newline", value: this.customFontSize().newLine});
            }
        }
        // draw line
        content.push({type:"newline",value:this.customFontSize().newLine});
        content.push({type: "line"});

        content.push({
            type: "newline",
            value: "14"
        }, {
            type: "text",
            value: `Reason :  ${
                job.note
            }`,
            style: {
                fontFamily: "Arial",
                fontSize: 10,
                fontStyle: "normal",
                align: "left"
            }
        }, {
            type: "newline",
            value: "14"
        }, {
            type: "text",
            value: `Sign : _________________ `,
            style: {
                fontFamily: "Arial",
                fontSize: 10,
                fontStyle: "normal",
                align: "left"
            }
        }, {
            type: "newline",
            value: "14"
        }, {
            type: "text",
            value: `*** Original Copy to Cashier ***`,
            style: {
                fontFamily: "Arial",
                fontSize: 10,
                fontStyle: "normal",
                align: "center"
            }
        });

        let cmd = {
            printerPreset: "0",
            timestamp: new Date().toISOString(),
            date: dayjs().format("YYYY-MM-DD"),
            jobId: new Date().valueOf().toString(),
            content
        };
        this.print_queues.push(cmd);
    }

    buildPrintByProductGroupOutput(job, printer, items, productGroupsHolder, presetIndex) {
        const settingsStore = useSettingsStore();
        const isShowItemPrice = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_JOB_SHOW_PRICE, false);
        let groups = this.reduceItemGroup(items, productGroupsHolder);
        let commentBill = job ?. commentBill || "";
        const queues = []
        groups.forEach((group, i) => {
            let content = [];
            let _logsText = "";
            // draw detail store
            content.push({
                    type: "text", key: "printerName", value: `printer${
                    printer.replace("p", "")
                } `,
                style: {
                    fontFamily: "Arial",
                    fontSize: 10,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "newline",
                value: "10"
            }, {
                type: "text",
                value: `Date :  ${
                    dayjs(job.timestamp).format("DD/MM/YYYY HH:mm:ss")
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "text",
                value: `Employee :  ${
                    job.employee.name
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            },
            // {
            //     type: 'text',
            //     value: `No Customer :  ${job.guests}`,
            //     style: {
            //         fontFamily: 'Arial',
            //         fontSize: 9,
            //         fontStyle: 'normal',
            //         align: 'left'
            //     }
            // },
                {
                type: "newline",
                value: "15"
            }, {
                type: "text",
                value: `Table ${
                    job.table
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 16,
                    fontStyle: "bold",
                    align: "center"
                }
            }, 
            {type:"newline",value:"10"},
            {
                type: "text",
                value: `Group ${
                    group.group.name
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: this.customFontSize().main,
                    fontStyle: "bold",
                    align: "center"
                }
            }, {
                type: "newline",
                value: "10"
            }, {type: "line"});

            // draw items
            content.push({type: "newline", value: this.customFontSize().newLine});
            for(let i = 0; i < group.items.length; i++){
                let item = group.items[i];
                content.push({
                        type: "text2cols", value: `${
                        item.qty
                    }   ${
                        item.name
                    }`,
                    value2: `${
                        isShowItemPrice ? item.price : " "
                    }`,
                    // value2: ` `,
                    style: {
                        fontFamily: "Arial",
                        fontSize: this.customFontSize().main,
                        fontStyle: "normal"
                    }
                });

                _logsText += `${
                    item.name
                } x${
                    item.qty
                }, `;

                if (item.options2 && item.options2.length > 0) {
                    item.options2.forEach((option) => {
                        content.push({
                                type: "text2cols", value: `     - ${
                                option.name
                            }  x${
                                option.qty
                            }`,
                            value2: ` `,
                            style: {
                                fontFamily: "Arial",
                                fontSize: this.customFontSize().sub,
                                fontStyle: "normal"
                            }
                        });
                    });
                }

                if (item.comments) {
                    content.push({
                            type: "text2cols", value: `     # ${
                            item.comments
                        }`,
                        value2: ` `,
                        style: {
                            fontFamily: "Arial",
                            fontSize: this.customFontSize().sub,
                            fontStyle: "normal"
                        }
                    });
                }

                // add newline if not last item
                if(i < group.items.length - 1){
                    content.push({type: "newline", value: this.customFontSize().newLine});
                }
            }
            // draw line
            content.push({type: "newline", value: this.customFontSize().newLine});
            content.push({
                type: "line"
            }, 
            {
                type: "newline",
                value: "10"
            },
            {
                type: "text",
                value: `Note : ***${commentBill}`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 10,
                    fontStyle: "bold"
                }
            });

            let cmd = {
                // printerName: PRINTER_NAME,
                printerPreset: presetIndex.toString(),
                timestamp: dayjs(job.timestamp).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                date: dayjs().format("YYYY-MM-DD"),
                jobId: job.jobId + i + "_" + printer,
                content,
                logs: true,
                table: job.table,
                logsText: _logsText
            };
            queues.push(cmd)
            this.print_queues.push(cmd);
        });

        this.checkAndUpdateItemJobToDb(job, items)
    }

    buildOneByOneOutput(job : any, printer : any, items : any, presetIndex : any) {
        const settingsStore = useSettingsStore();
        const isShowItemPrice = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_JOB_SHOW_PRICE, false);
        let commentBill = job ?. commentBill || "";
        const queues = []
        items.forEach((item, i) => { // one by one
            let content = [];
            let _logsText = `${
                item.name
            } x${
                item.qty
            }, `;

            content.push({
                    type: 'text', key: "printerNameAndDate", value: `printer${
                    printer.replace("p", "")
                }  :  ${
                    dayjs(job.timestamp).format('DD/MM/YYYY HH:mm:ss')
                }`,
                style: {
                    fontFamily: 'Arial',
                    fontSize: 9,
                    fontStyle: 'normal',
                    align: 'left'
                }
            }, {
                type: "text",
                value: `Employee :  ${
                    job.employee.name
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "left"
                }
            }, {
                type: "newline",
                value: "10"
            }, {
                type: "text",
                value: `${
                    job.table
                }`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 14,
                    fontStyle: "bold",
                    align: "center"
                }
            }, {
                type: "newline",
                value: "10"
            }, {
                type: "line"
            }, {
                type: "newline",
                value: "10"
            }, 
            {
                type: "text2cols",
                value: `${
                    item.qty
                }  ${
                    item.name
                }`,
                value2: `${
                    isShowItemPrice ? item.price : ""
                }`,
                // value2: ` `,
                style: {
                    fontFamily: "Arial",
                    fontSize: this.customFontSize().main,
                    fontStyle: "normal"
                }
            });

            if (item.options2 && item.options2.length > 0) {
                item.options2.forEach((option) => {
                    content.push({
                            type: "text2cols", value: `     - ${
                            option.name
                        }  x${
                            option.qty
                        }`,
                        value2: ` `,
                        style: {
                            fontFamily: "Arial",
                            fontSize: this.customFontSize().sub,
                            fontStyle: "normal"
                        }
                    });
                });
            }

            if (item.comments) {
                content.push({
                        type: "text2cols", value: `     # ${
                        item.comments
                    }`,
                    value2: ` `,
                    style: {
                        fontFamily: "Arial",
                        fontSize: this.customFontSize().sub,
                        fontStyle: "normal"
                    }
                });
            }

            content.push({
                type: "newline",
                value: "10"
            }, {
                type: "line"
            }, 
            {
                type: "newline",
                value: "10"
            },
            {
                type: "text",
                value: `Note : ***${commentBill}`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 10,
                    fontStyle: "bold"
                }
            }, {
                type: "text",

                value: `(${
                    i + 1
                }/${
                    items.length
                })`,
                style: {
                    fontFamily: "Arial",
                    fontSize: 9,
                    fontStyle: "normal",
                    align: "right"
                }
            }, {
                type: "newline",
                value: "10"
            });
            let cmd = {
                printerPreset: presetIndex.toString(),
                timestamp: dayjs(job.timestamp).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                date: dayjs().format("YYYY-MM-DD"),
                jobId: job.jobId + "_" + printer + "_" + item.productId + "_" + i,
                content,
                logs: true,
                logsText: _logsText,
                table: job.table
            };

            queues.push(cmd)
            this.print_queues.push(cmd);
        });

        
        this.checkAndUpdateItemJobToDb(job, items)
    }

    buildOneQtyEachOutput(job : any, printer : any, items : any, presetIndex : any) {
        const settingsStore = useSettingsStore();
        const isShowItemPrice = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_JOB_SHOW_PRICE, false);
        let commentBill = job ?. commentBill || "";
        const queues = []
        items.forEach((item, i) => {
            for (let index = 0; index < item.qty; index++) { // one by one
                let content = [];
                let _logsText = `${
                    item.name
                } x1,`;

                content.push({
                        type: "text", key: "printerNameAndDate", value: `printer${
                        printer.replace("p", "")
                    }  :  ${
                        dayjs(job.timestamp).format("DD/MM/YYYY HH:mm:ss")
                    }`,
                    style: {
                        fontFamily: "Arial",
                        fontSize: 9,
                        fontStyle: "normal",
                        align: "left"
                    }
                }, {
                    type: "text",
                    value: `Employee :  ${
                        job.employee.name
                    }`,
                    style: {
                        fontFamily: "Arial",
                        fontSize: 9,
                        fontStyle: "normal",
                        align: "left"
                    }
                }, {
                    type: "newline",
                    value: "10"
                }, {
                    type: "text",
                    value: `${
                        job.table
                    }`,
                    style: {
                        fontFamily: "Arial",
                        fontSize: 14,
                        fontStyle: "bold",
                        align: "center"
                    }
                }, {
                    type: "newline",
                    value: "10"
                }, {
                    type: "line"
                }, {
                    type: "newline",
                    value: "10"
                }, 
                {
                    type: "text2cols",
                    value: `1  ${
                        item.name
                    }`,
                    value2: `${
                        isShowItemPrice ? item.price : ""
                    }`,
                    // value2: ` `,
                    style: {
                        fontFamily: "Arial",
                        fontSize: this.customFontSize().main,
                        fontStyle: "normal"
                    }
                });

                if (item.options2 && item.options2.length > 0) {
                    item.options2.forEach((option) => {
                        content.push({
                                type: "text2cols", value: `     - ${
                                option.name
                            }  x${
                                option.qty
                            }`,
                            value2: ` `,
                            style: {
                                fontFamily: "Arial",
                                fontSize: this.customFontSize().sub,
                                fontStyle: "normal"
                            }
                        });
                    });
                }

                if (item.comments) {
                    content.push({
                            type: "text2cols", value: `     # ${
                            item.comments
                        }`,
                        value2: ` `,
                        style: {
                            fontFamily: "Arial",
                            fontSize: this.customFontSize().sub,
                            fontStyle: "normal"
                        }
                    });
                }

                content.push({
                    type: "newline",
                    value: "10"
                }, {
                    type: "line"
                }, 
                {
                type: "newline",
                value: "10"
                },
                {
                    type: "text",
                    value: `Note : ***${commentBill}`,
                    value2: `(${
                        index + 1
                    }/${
                        item.qty
                    })`,
                    style: {
                        fontFamily: "Arial",
                        fontSize: 10,
                        fontStyle: "bold"
                    }
                }, {
                    type: "text",
                    value: `(${
                        index + 1
                    }/${
                        item.qty
                    })`,
                    style: {
                        fontFamily: "Arial",
                        fontSize: 9,
                        fontStyle: "normal",
                        align: "right"
                    }
                }, {
                    type: "newline",
                    value: "10"
                });

                let cmd = {
                    printerPreset: presetIndex.toString(),
                    timestamp: dayjs(job.timestamp).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                    date: dayjs().format("YYYY-MM-DD"),
                    jobId: `${
                        job.jobId
                    }_${printer}_${
                        item.productId
                    }_${i}_${index}`,
                    content,
                    logs: true,
                    logsText: _logsText,
                    table: job.table
                };
                queues.push(cmd)
                this.print_queues.push(cmd);
            }
        });

        this.checkAndUpdateItemJobToDb(job, items)
    }

    buildSummaryOuput(job, printer, items, presetIndex) {
        const settingsStore = useSettingsStore();
        const isShowItemPrice = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_JOB_SHOW_PRICE, false);
        let content = [];
        let _logsText = "";
        let commentBill = job ?. commentBill || "";

        // draw detail store
        content.push({
                type: "text", key: "printerNameAndDate", value: `printer${
                printer.replace("p", "")
            }  :  ${
                dayjs(job.timestamp).format("DD/MM/YYYY HH:mm:ss")
            }`,
            style: {
                fontFamily: "Arial",
                fontSize: 9,
                fontStyle: "normal",
                align: "left"
            }
        }, {
            type: "text",
            value: `Employee :  ${
                job.employee.name
            }`,
            style: {
                fontFamily: "Arial",
                fontSize: 9,
                fontStyle: "normal",
                align: "left"
            }
        },
        // {
        //     type: 'text',
        //     value: `No Customer :  ${job.guests}`,
        //     style: {
        //         fontFamily: 'Arial',
        //         fontSize: 9,
        //         fontStyle: 'normal',
        //         align: 'left'
        //     }
        // },
            {
            type: "newline",
            value: "5"
        }, {
            flag: "commentBill",
            type: "text",
            value: `Note : ***${commentBill}`,
            style: {
                fontFamily: "Arial",
                fontSize: 12,
                fontStyle: "bold",
                align: "left"
            }
        }, {
            type: "newline",
            value: "10"
        }, {
            type: "text",
            value: `${
                job.table
            }`,
            style: {
                fontFamily: "Arial",
                fontSize: 16,
                fontStyle: "bold",
                align: "center"
            }
        }, {
            type: "newline",
            value: "10"
        }, {type: "line"});

        content.push({type: "newline", value: this.customFontSize().newLine});
        // draw items

       for (let i = 0; i < items.length; i++) {
        let item = items[i];
            content.push({
                    type: "text2cols", value: `${
                    item.qty
                }  ${
                    item.name
                }`,
                value2: `${
                    isShowItemPrice ? item.price : " "
                }`,
                // value2: ` `,
                style: {
                    fontFamily: "Arial",
                    fontSize: this.customFontSize().main,
                    fontStyle: "normal"
                }
            });

            _logsText += `${
                item.name
            } x${
                item.qty
            }, `;

            if (item.options2 && item.options2.length > 0) {
                item.options2.forEach((option) => {
                    content.push({
                            type: "text2cols", value: `     - ${
                            option.name
                        }  x${
                            option.qty
                        }`,
                        value2: ` `,
                        style: {
                            fontFamily: "Arial",
                            fontSize: this.customFontSize().sub,
                            fontStyle: "normal"
                        }
                    });
                });
            }

            if (item.comments) {
                content.push({
                        type: "text2cols", value: `     # ${
                        item.comments
                    }`,
                    value2: ` `,
                    style: {
                        fontFamily: "Arial",
                        fontSize: this.customFontSize().sub,
                        fontStyle: "normal"
                    }
                });
            }

            // add newline if not last item
            if(i < items.length - 1){
                content.push({type: "newline", value: this.customFontSize().newLine});
            }
        
        }
        // draw line
        content.push({type: "newline", value: this.customFontSize().newLine});
        content.push({type: "line"});

        content = this.filterFlagOut(content, "commentBill", commentBill);

        let cmd = {
            // printerName: PRINTER_NAME,
            printerPreset: presetIndex.toString(),
            timestamp: dayjs(job.timestamp).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            date: dayjs().format("YYYY-MM-DD"),
            jobId: job.jobId + "_" + printer,
            content,
            logs: true,
            table: job.table,
            logsText: _logsText
        };
        this.print_queues.push(cmd);

        this.checkAndUpdateItemJobToDb(job, items)
    }

    reduceItemGroup(items, productGroupsHolder) {
        let groups = items.reduce((acc, value) => {
            let group = productGroupsHolder[value.productId];
            if (acc[group.productId] == undefined) {
                acc[group.productId] = {
                    group: {},
                    items: []
                };
            }
            acc[group.productId]["group"] = group;
            acc[group.productId]["items"].push(value);
            return acc;
        }, {});

        return Object.values(groups);
    }

    customFontSize() {
        const settingsStore = useSettingsStore();
        const customFontSize =  settingsStore.getValueBysettingId(SETTING_ID.PRINTER_JOB_KITCHEN_FONT_SIZE, 16);        
        const fontSize = transfromFontSize("kitchen", customFontSize) 
        return {
            main:fontSize,
            sub:Math.ceil(parseFloat(fontSize) * 0.9), //90%
            newLine:Math.ceil(parseFloat(fontSize) * 0.5), //50%
        }
    }

    getTableState(table : String) {
        const posStore = usePosStore();
        return posStore.tableState[table];
    }

    filterFlagOut(content : any, flagName : string, flagValue : any) {
        let cloneContent = [...content];
        if (!flagValue) {
            cloneContent = cloneContent.filter((c) => {
                if (c.flag == undefined) {
                    return c;
                }

                if (c.flag !== flagName) {
                    return c;
                }
            });
        }

        return cloneContent;
    }

    convertPrinterPresetToIndex(printerPreset) {
        let _printerPreset = printerPreset
        _printerPreset = printerPreset.replace("p", "")
        return parseInt(_printerPreset)
    }

    splitPrinterData(input, newPrintText) {
        const parts = input.split("  :  ");
        if (parts.length === 2) {
            return {printer: newPrintText, timestamp: parts[1].trim()};
        }
        return null; // Return null if format is incorrect
    }

    printerMappingWithCode(printerCode : string) {
        const printers = {
            p0: 0,
            p1: 1,
            p2: 2,
            p3: 3,
            p4: 4,
            p5: 5
        }
        return printers[printerCode]
    }

    updateJobToFirestore(data:any){
      const firestoreDb = useFirebaseFirestore();
      const subDocId = dayjs().format("YYYY-MM-DD")
      let ref = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.CHECK_PRINT, subDocId)  
      setDoc(ref, data, { merge: true });
    }

    getCheckPrinter(){
        const firestoreDb = useFirebaseFirestore();
        const subDocId = dayjs().format("YYYY-MM-DD")
        let ref = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.CHECK_PRINT, subDocId)  
        
        getDoc(ref).then((doc) => {
            if (doc.exists()) {
                return doc.data()
            } else {
                return null
            }
        });
    }

    checkAndUpdateItemJobToDb(job : any, items : any){
        return
        const itemsHolder = items.reduce((acc : any, item : any) => {
            acc[item.productId] = item
            return acc
        }, {})

        const newItems = job.items.map((item : any) => ({
            ...item,
            originalPrinter: this.printerOriginalHolder[item.productId] || null,
            forwardPrinters: itemsHolder[item.productId]?.forwardPrinters || null           
        }))

        const checkPrinterData = this.getCheckPrinter()
        const oldJob = checkPrinterData?.items || []
        const payload = {
            [job.jobId]: {
                ...job,
                createdAt: dayjs().add(7, 'hour').toISOString(),    
                items: [...oldJob, ...newItems],
                ttl: dayjs().add(7, 'hour').add(14, 'day').toISOString(),
            }
        }
        this.updateJobToFirestore(payload)
    }
}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { ThermalPrinterJob };
